import AdminLayout from "./AdminLayout";
import PaymentOrdersManagement from "./PaymentOrdersManagement";

function PaymentOrders() {
  return (
    <AdminLayout>
      <PaymentOrdersManagement />
    </AdminLayout>
  );
}

export default PaymentOrders;
